import React, {  useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { logoURL } from '../../assets/images/logourl'
import { useStore } from '../../context/store.provider'
import { ROUTES_LINKS } from '../../routes/routes'
import { writeToDataBase } from '../user/GettingData/firebase'
import './CreatProduct.css'



function CreateProduct() {
  
  const navigate = useNavigate()
  const {storeProducts}= useStore()
  const [productName, setProductName] = useState('')
  const [category, setCategory] = useState('')
  const [imgUrl, setImgUrl] = useState('')
  const [price, setPrice] = useState('')
  const [quantity,setQuantity] = useState('')
  const [storePrice, setStorePrice] = useState('')
  const [salePrice, setSalePrice] = useState(null)
  const onChangeName = ({ target: { value } }) => {
    setProductName(value)
  }
  const onChangeCategory = ({ target: { value } }) => {
    setCategory(value)
  }
  const onChangeImg = ({ target: { value } }) => {
    setImgUrl(value)
  }
  const onChangePrice = ({ target: { value } }) => {
    setPrice(value)
  }
  const onChangeStorePrice = ({ target: { value } }) => {
    setStorePrice(value)
  }
  const onChangeQuantity = ({ target: { value } }) => {
    setQuantity(value)
  }
  const onChangeSalePrice = ({ target: { value } }) => {
    setSalePrice(value)
  }
  
  // useEffect(() => {
  //   if (!productName === '' && !category === '') {}
      
  //   },[productName, category])

  const NewProduct = {
    productName: productName,
    category: category,
    imgUrl: imgUrl? imgUrl:logoURL,
    price: Number(price),
    quantity:quantity ? Number(quantity) : 1,
    storePrice:Number(storePrice),
    outOfStock:false,
    id:storeProducts.length + 1,
    salePrice:Number(salePrice),
    edited:false
    // here length of the data array + 1
  }

  // here need to connect to the firebase realtime data base
  const sendProduct = async () => {
    if(NewProduct.productName&&NewProduct.category){

      writeToDataBase(NewProduct,storeProducts.length)
    }else{
      alert("write product name")
    }
    // here need to do validation that there is product
    // here length of the data array
  }
  const onClickPost = () => {
    sendProduct()
    setProductName('')
    setCategory('')
    setImgUrl('')
    setPrice('')
    setStorePrice('')
    setQuantity('')
}


const handleNavigationToAdminSite =()=>{
  navigate(ROUTES_LINKS.TO_ADMIN_SITE)
}
return (
  <div className='create-product'>
    <h1> הוסף מוצר חדש</h1>
    <input required onChange={onChangeName} value={productName} placeholder='שם מוצר' />
    <input required onChange={onChangeCategory} value={category} placeholder='קטגוריה' />
    <input onChange={onChangeImg} value={imgUrl} placeholder='כתובת תמונה' />
    <input onChange={onChangeStorePrice} type="number" value={storePrice} placeholder='מחיר קרן' />
    <input onChange={onChangePrice}  value={price} placeholder='מחיר' />
    <input onChange={onChangeQuantity} type="number"  value={quantity} placeholder='כמות במלאי' />
    <input onChange={onChangeSalePrice}  value={salePrice} placeholder='מחיר מבצע' />
    <button className='create-btn' onClick={onClickPost}>צור מוצר</button>
    <button onClick={handleNavigationToAdminSite}><i className="fa-solid fa-backward"></i> חזרה לאתר מנהל  </button>
  </div>
)
}

export default CreateProduct